import React from "react";

import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import SsidChartIcon from "@mui/icons-material/SsidChart";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import { SxProps } from "@mui/material";
import { CharacteristicsEmptyList } from "assets/material-custom-icons";

import { ReactComponent as AdditionalReportsIcon } from "../../../../assets/icons/additional-reports.svg";
import { ReactComponent as AssetBenchmark } from "../../../../assets/icons/asset-benchmark.svg";
import { ReactComponent as BulletedList } from "../../../../assets/icons/bulleted-list-outline.svg";
import { ReactComponent as Cloud } from "../../../../assets/icons/cloud.svg";
import { ReactComponent as MyPortfolio } from "../../../../assets/icons/my-portfolio.svg";
import { ReactComponent as PortfolioIcon } from "../../../../assets/icons/portfolio-overview.svg";
import { ReactComponent as TaskIcon } from "../../../../assets/icons/task.svg";

const permissionIcon = {
  deals: (sx?: SxProps) => <MyPortfolio style={{ ...sxToStyle(sx), width: "15px" }} />,
  smart_sheet: (sx?: SxProps) => <BulletedList style={{ ...sxToStyle(sx), width: "15px" }} />,
  task_manager: (sx?: SxProps) => <TaskIcon style={{ ...sxToStyle(sx), width: "15px" }} />,
  cloud_integrations: (sx?: SxProps) => <Cloud style={{ ...sxToStyle(sx), width: "15px" }} />,
  social: (sx?: SxProps) => <PeopleAltOutlinedIcon sx={{ ...sx, width: "15px", height: "15px" }} />,
  portfolio_analysis: (sx?: SxProps) => <PortfolioIcon style={{ ...sxToStyle(sx), width: "15px" }} />,
  benchmark: (sx?: SxProps) => <AssetBenchmark style={{ ...sxToStyle(sx), width: "15px", height: "17px" }} />,
  external_reports: (sx?: SxProps) => <SsidChartIcon sx={{ ...sx, width: "15px", height: "15px" }} />,
  deal_metrics: (sx?: SxProps) => <AdditionalReportsIcon style={{ ...sxToStyle(sx), width: "15px", height: "17px" }} />,
  portfolio_construction: (sx?: SxProps) => (
    <BusinessCenterIcon sx={{ ...sxToStyle(sx), width: "15px", height: "17px" }} />
  ),
  characteristics: (sx?: SxProps) => <CharacteristicsEmptyList sx={{ ...sx, width: "15px", height: "17px" }} />,
  file_upload: (sx?: SxProps) => <UploadFileOutlinedIcon sx={{ ...sx, width: "15px", height: "15px" }} />
};

const sxToStyle = (sx?: SxProps): React.CSSProperties => {
  if (!sx || typeof sx === "string") return {};
  return sx as React.CSSProperties;
};

export interface PermissionIconProps {
  type: string;
  sx?: SxProps;
}

export const PermissionIcon: React.FC<PermissionIconProps> = ({ type, sx }) => {
  const IconRenderer = permissionIcon[type as keyof typeof permissionIcon];

  if (!IconRenderer) {
    console.warn(`No icon found for type "${type}"`);
    return null;
  }

  return IconRenderer(sx);
};
